import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useField } from 'react-final-form';
import { printGuestType } from 'lib/util/util';
import { GuestType } from 'models/product';

import { NumberInputModal } from './NumberInputModal';

interface Props {
  guestType: GuestType;
  minimumParticipants: number;
  maximumParticipants: number;
  className?: string;
}

const MAX_OPTION_NUMBER = 20;
const UNLIMITED = 100000;

const range = (start: number, stop: number): number[] => {
  if (start > stop) {
    return [];
  }

  return [...Array(stop - start + 1).keys()].map((item) => item + start);
};

export const NumberInputGuestTypeListItem = ({
  guestType,
  minimumParticipants,
  maximumParticipants,
  className,
}: Props) => {
  const { t } = useTranslation();
  const { input } = useField(`guestCount.${guestType.key}`);
  const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false);

  const isUnlimited = maximumParticipants === UNLIMITED;

  return (
    <>
      <li className={className} key={guestType.key}>
        <label className="widget-calendar-pax-select">
          <p className="widget-calendar-selectTitle">{printGuestType(guestType, t)}</p>
          <p className="widget-calendar-select__num">{input.value || '0'}</p>
          <select
            className="widget-calendar-select__item"
            value={input.value}
            onChange={(e) => {
              if (e.target.value === 'more') {
                setIsModalOpen(true);
                return;
              }
              input.onChange(e.target.value);
            }}
          >
            {range(
              minimumParticipants,
              isUnlimited && maximumParticipants > MAX_OPTION_NUMBER
                ? MAX_OPTION_NUMBER
                : maximumParticipants
            ).map((c) => (
              <option value={c} key={c}>
                {c}
              </option>
            ))}
            {Number(input.value) > MAX_OPTION_NUMBER && (
              <option value={input.value}>{input.value}</option>
            )}
            {isUnlimited && maximumParticipants > MAX_OPTION_NUMBER && (
              <option value={'more'}>{t('more than {{max}}', { max: MAX_OPTION_NUMBER })}</option>
            )}
          </select>
        </label>
        {isModalOpen && (
          <NumberInputModal
            guestType={guestType}
            open={isModalOpen}
            onClose={() => setIsModalOpen(false)}
          />
        )}
      </li>
    </>
  );
};
